<div class="sales-order-line-items-transfer-order-dialog">
  <div class="lum-c-sales-order-line-items-transfer-order-dialog__header">
    <h2 mat-dialog-title>Transfer Order</h2>
  </div>

  <lum-ui-autocomplete
    placeholder="Search source warehouse"
    [debounceTime]="500"
    [options]="warehouses || []"
    [displayProperty]="'location_name'"
    [loading]="loading$ | async"
    (inputChangeEvent)="onSearchWarehouses($event)"
    (optionSelectedEvent)="onSelectWarehouse($event)"
  ></lum-ui-autocomplete>

  <mat-dialog-actions align="end">
    <button class="lum-button lum-button--tertiary mr-2" mat-dialog-close>
      Cancel
    </button>
    <button class="lum-button" (click)="onSubmit()" cdkFocusInitial>
      Submit
    </button>
  </mat-dialog-actions>
</div>
